import { applyMiddleware, combineReducers, createStore } from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createBrowserHistory } from 'history'
import { createReduxHistoryContext } from 'redux-first-history'
import { getFirebase } from 'react-redux-firebase'
import reducers from './reducers'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'

// redux-first-history
const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({
    history: createBrowserHistory(),
    reduxTravelling: true,
  })

// middleware
const enhancers = composeWithDevTools(
  applyMiddleware(routerMiddleware, thunk.withExtraArgument(getFirebase))
)

// redux-persist
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['alternateArt', 'clipboard', 'settings'],
}
const rootReducer = combineReducers({
  ...reducers,
  router: routerReducer,
})
const persistedReducer = persistReducer(persistConfig, rootReducer)

export default function configureStore(preloadedState) {
  const store = createStore(persistedReducer, preloadedState, enhancers)
  const history = createReduxHistory(store)
  const persistor = persistStore(store)
  return { history, persistor, store }
}
